module.exports = __webpack_public_path__ + "img/custom_a_banner.19e01aa.jpg";